module.exports = __webpack_public_path__ + "static/media/left_attack.a80e8ab7.png";